<template>
    <input
        ref="element"
        v-on="{
            ...( mask && {
                input: validateMask
            })
        }"
        @change="action"
        @keyup.enter="action"
    >
</template>

<script>
// packages
import { ref, onMounted } from '@vue/composition-api';

// hooks
import { reset } from '@/hooks/use-input-listeners';

// plugins
import applyMask from '@/plugins/input-mask';

export default {
    props: {
        reset: Boolean,
        defaultValue: String,
        mask: String
    },
    setup ( props, { emit }) {
        // reactive vars
        const element = ref( null );

        onMounted( () => {
            // listener para quando for necessário
            // proceder a um reset a input.
            reset({ props, object: element.value, key: 'value' });
        });

        // emissão do valor da input para o
        // componente pai.
        const action = $event => {
            const input = $event.target;
            emit( 'input', input.value );
        };

        // validação da mascára.
        const validateMask = () => {
            const newValue = element.value.value;
            element.value.value = applyMask( newValue, props.mask );
        };

        return { element, action, validateMask };
    }
};
</script>